import { lazy } from 'react';

//User Dashboard
export const UserDashboard = lazy(() => import(/*webpackChunkName: "user dashboard" */ './dashboard/index.jsx'));

//User Cases
export const UserCases = lazy(() => import(/*webpackChunkName: "user cases" */ './cases/index.jsx'));

//User Orders
export const UserOrders = lazy(() => import(/*webpackChunkName: "user orders" */ './orders/index.jsx'));

//User Order Detail
export const UserOrderDetail = lazy(
  () => import(/*webpackChunkName: "user order detail" */ './order-detail/index.jsx'),
);

//User Products
export const UserProducts = lazy(() => import(/*webpackChunkName: "user products" */ './products/index.jsx'));

//User Subscriptions
export const UserSubscriptions = lazy(
  () => import(/*webpackChunkName: "user subscriptions" */ './subscriptions/index.jsx'),
);

//User Subscription Detail
export const UserSubscriptionDetail = lazy(
  () => import(/*webpackChunkName: "user subscription detail" */ './subscription-detail/index.jsx'),
);

//User Contacts
export const UserContacts = lazy(() => import(/*webpackChunkName: "user contacts" */ './contacts/index.jsx'));

//User Profile
export const UserProfile = lazy(() => import(/*webpackChunkName: "user profile" */ './profile/index.jsx'));

//User Chat
export const UserChat = lazy(() => import(/*webpackChunkName: "user chat" */ './chat/index.jsx'));

//User Faqs
export const UserFaqs = lazy(() => import(/*webpackChunkName: "user faqs" */ './faqs/index.jsx'));

//User Affiliate Path
export const UserAffiliate = lazy(() => import(/*webpackChunkName: "user affiliate" */ './affiliate/index.jsx'));

//User Lab Works Path
export const UserLabWork = lazy(() => import(/*webpackChunkName: "user lab works" */ './lab-work/index.jsx'));

//User My Labs Documents Path
export const UserMyLabs = lazy(() => import(/*webpackChunkName: "user my labs" */ './my-labs/index.js'));

//User Checkout Success
export const UserCheckoutSuccess = lazy(
  () => import(/*webpackChunkName: "user/checkout-success" */ './checkouts/checkout-success/index.jsx'),
);

export const UserCheckoutFailure = lazy(
  () => import(/*webpackChunkName: "user/checkout-failure" */ './checkouts/checkout-failure/index.jsx'),
);

export const UserVerifyEmail = lazy(
  () => import(/*webpackChunkName: "user/verify-email" */ './verify-email/index.jsx'),
);
